
export const GRID_HEIGHT = 51; // height of grid unit in pixels
export const GRID_WIDTH = 46; // width of grid unit in pixels
export const REPLACE = 0; // for autoscroll

export const MIN_DURATION = 15 * 60; // 1min in sec
export const THROTTLE = 100;